const cutLongText = {}

cutLongText.install = function (Vue) {
  /*
  * Trunca el texto por una cantidad de caracteres por parametro
  */
  Vue.filter('cutLongText', (text, length, clamp) => {
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
  })
}

export default cutLongText


// WEBPACK FOOTER //
// ./src/utils/filters/cutLongText.js